import * as React from "react";
import type { SVGProps } from "react";
const SvgCancelLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M15.6 15.6 8.4 8.4M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0Z"
      opacity={0.9}
    />
  </svg>
);
export default SvgCancelLeft;
